////    CORE    ////
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

////    COMPONENTS    ////
import { IconModule, LoaderButtonModule } from '@helvetia/components'
import { AppRoutingModule } from 'src/app/app-routing.module'
import { MaterialImporterModule } from 'src/app/shared/material-importer/material-importer.module'
import { HomeComponent } from './home.component'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MarketsModule } from 'src/app/components/markets/markets.module'

@NgModule({
  declarations: [HomeComponent],
  imports: [
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    IconModule,
    LoaderButtonModule,
    MaterialImporterModule,
    MarketsModule
  ],
})
export class HomeModule {}
